/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close-stroke': {
    width: 26,
    height: 26,
    viewBox: '0 0 26 26',
    data: '<g transform="rotate(90 12.205 13)" _stroke="#4A4A4A" _fill="none" fill-rule="evenodd"><circle pid="0" cx="12" cy="12" r="12"/><g stroke-linecap="round" stroke-linejoin="round"><path pid="1" d="M11.973 6.179l-.048 11.36M6.269 11.883h11.313"/></g></g>'
  }
})
